import React, {
  type ComponentType,
  type ReactElement,
  type ReactNode,
  useCallback,
  useMemo,
  useState,
} from "react";
import { FormattedMessage } from "react-intl";
import { Button, type ButtonProps } from "reactstrap";
import styled from "styled-components";

export interface IShowableProps {
  defaultShown?: boolean;
  children: (shown: boolean, button: ReactNode) => ReactNode;
  ButtonClass?: ComponentType<ButtonProps>;
}

export function Showable({
  defaultShown,
  children,
  ButtonClass = ShowableButtonStyled,
}: IShowableProps): ReactElement {
  const [shown, setDefaultShown] = useState<boolean>(Boolean(defaultShown));
  const handleToggle = useCallback(() => {
    setDefaultShown((prevShown) => {
      return !prevShown;
    });
  }, []);

  const button = useMemo(
    () => (
      <ButtonClass onClick={handleToggle} outline>
        {shown ? (
          <FormattedMessage id="ui.hide" />
        ) : (
          <FormattedMessage id="ui.show" />
        )}
      </ButtonClass>
    ),
    [ButtonClass, handleToggle, shown],
  );
  return <>{children(shown, button)}</>;
}

export const ShowableInputRow = styled.div`
  position: relative;
`;

export const ShowableButtonStyled = styled(Button)`
  border-radius: 3px;
  padding: 3px 5px;
  font-size: 13px;
  border-color: #dadce0;
  background: white;

  &:hover {
    background: #80bdff;
    border-color: #80bdff;
  }

  &:focus {
    box-shadow: 0 0 0 0.2rem #80bdff;
  }
`;

export const ShowableInputButtonStyled = styled(ShowableButtonStyled)`
  position: absolute;
  top: 5px;
  right: 5px;
`;
